import axios from "axios";

const EmpDetailsService = {
  GetEmployeeList: () =>
    axios.get("EmployeeDetails/GetEmployeeList"),

  GetEmployeeDetails: (serviceNo) =>
    axios.get(`EmployeeDetails/GetEmployeeDetails?serviceNo=${serviceNo}`),

  GetEmployeeImage: (serviceNo) =>
    `https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${serviceNo}`,

  GetEmployeeOtherInfo: (serviceNo) =>
    axios.get(`EmployeeDetails/GetEmployeeOtherInfo?serviceNo=${serviceNo}`),

  GetEmployeeNoPay: (serviceNo, currentYear, startMonth, endMonth, newYear) =>
    axios.get(`EmployeeDetails/GetEmployeeNoPay?serviceNo=${serviceNo}&currentYear=${currentYear}&startMonth=${startMonth}&endMonth=${endMonth}&newYear=${newYear}`),

  GetEmployeePreYearSummary: (serviceNo) =>
    axios.get(`EmployeeDetails/GetEmployeePreYearSummary?serviceNo=${serviceNo}`),

  GetEmployeeAttendanceCard: (serviceNo, year, month) =>
      axios.get(`EmployeeDetails/GetEmployeeAttendanceCard?serviceNo=${serviceNo}&year=${year}&month=${month}`),

};

export default EmpDetailsService;